export const ResetPassword = {
	title: "Tilbakestill passord",
	explanation: "Skriv inn ditt nye passord nedenfor for å tilbakestille kontopassordet.",
	repeat_password_label: "Gjenta passord",
	button_text: "Tilbakestill passord",
	loading_button_text: "Tilbakestiller...",
	remember_password_text: "Husker du passordet ditt?",
	login_button_text: "Logg inn",
	success_title: "Passord tilbakestilt",
	success_explanation: "Ditt passord har blitt tilbakestilt. Du kan nå logge inn med ditt nye passord.",
};
